import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { HVAC } from '../../../../job/truss-hitl/HVAC';
import { Parameter } from '../../../../job/truss-hitl/Parameter';
import { Type as Polygon } from '../../../../job/truss-hitl/polygon/Type';
import { Name } from '../../../../job/truss-hitl/svg/Name';
import { Point } from '../../../../ui/geometry/Point';

const UpdatedScale = struct({
	value: Parameter,
	referencePoints: array(Point),
	referenceMeasurement: string,
	referenceSvgFileName: Name,
});

export const Request = intersect(
	struct({
		drawingId: string,
	})
)(
	partial({
		polygons: array(Polygon),
		scale: UpdatedScale,
		hvac: HVAC,
	})
);
